import React ,{Component} from 'react';
import Loader from "../../../loader";
import Grid from '@material-ui/core/Grid';
import {makeStyles, withStyles} from '@material-ui/core/styles';
import LinearProgress from '@material-ui/core/LinearProgress';
import Typography from '@material-ui/core/Typography';
import Checkbox from '@material-ui/core/Checkbox';
import customStyle from "../../../../Assets/CSS/stylesheet_UHS";
import Button from "@material-ui/core/Button";
import customeClasses from "../Eligibility.css";
import i18n from "../../../../i18next";
import axios from 'axios';
import configurations from "../../../../configurations";
import {connect} from "react-redux";
import { Table, TableCell,Paper, TableBody, TableHead, TableRow, Tooltip } from '@material-ui/core';
import "../Add-ons/addOnsScreen.css"

const StyledTableCell = withStyles(theme => (customStyle.tableCell))(TableCell);
const StyledTableRow = withStyles(theme => (customStyle.tableRow))(TableRow);

// Carrier drives which stepper/quote this session belongs to: "Sharing Programs" => UHF, "Insurance Plans" => VERA.
const getStepperTypeFromCookies = (cookiesData) => {
    return cookiesData.actionType;
};
const ACSMCheckbox = withStyles({
    root: {
        color: '#1a2c40',
        "&$checked": {
            color: '#1a2c40',
        },
        "&$disabled": {
            color: 'grey'
        }
    },
    checked: {},
    disabled: {
        color: 'grey'
    }
})(Checkbox);

const styles = props => (
    customStyle.chkEligiScreen
);

const WizardButton = withStyles(
    customStyle.viewBtn
)(Button);

const ProceedButton = withStyles(
    customStyle.proceedBtn
)(Button);
const NextButton = withStyles(
    customStyle.NextButton
)(Button);
const BackButton = withStyles(
    customStyle.backBtn
)(Button);


class ReviewChoice extends Component{
    constructor(props) {
        super(props);
        this.state = {
            headerData : [],
            addOnsBodyData : [],
            loaderShow : true,
            progress : 0,
            count : 0,
            healthTool : false,
            membersArr : [],
            check:false,
            reviewChoicesTab: 'summary',
            reviewSummaryData: null,
            reviewFamilyData: null,
        }
    }

    componentDidMount=()=> {
        sessionStorage.setItem('current_screen', String(this.props.activeStep));
        let subId = JSON.parse(localStorage.getItem('CurrentLoginUser')).id;
        axios.get(configurations.baseUrl + "/enrollment/saveCompletionStatus/" + subId + "/" + sessionStorage.getItem('current_screen'))
            .then((response) => {
                if (response && response.data.code === 200) console.log(response.data.code)
            })
            .catch((error) => console.log(error));
        this.fetchReviewChoicesData();
    }

    fetchReviewChoicesData = () => {
        let cookiesData = JSON.parse(sessionStorage.getItem('STATE_PARAM')) || {};
        let subId = this.props.subId || cookiesData.subID || cookiesData.user_subId;
        let brokerId = cookiesData.brokerId;
        let stepperType = getStepperTypeFromCookies(cookiesData);
        let type = cookiesData.carrier || 'UHF'; // Default to 'UHF' if not found in cookies
        if (!subId || !brokerId) {
            this.setState({ loaderShow: false });
            return;
        }
        axios.get(configurations.baseRootUrl + '/veraenroll/api/v1/quote/review-choices/' + subId + '/' + type + '/' + brokerId + `?productType=${stepperType}`)
            .then((response) => {
                this.setState({
                    reviewSummaryData: response.data.programFees,
                    reviewFamilyData: response.data.familyBreakdown,
                    loaderShow: false,
                });
            }).catch((error) => {
                console.log(error);
                this.setState({ loaderShow: false });
            });
    }

    handleBack = () =>{
        this.props.onClickjumpfive();
    }

    handleProceed = (e) =>{
        if (e.detail === 1){
        this.props.onClick();
        }
    }
    renderProgramSummary() {
        if (!this.state.reviewSummaryData) {
            return <div style={{ padding: '20px', fontSize:'14px', fontFamily : 'Roboto, Arial, Helvetica, sans-serif' }}>No data available.</div>;
        }
        return (
            <div>
                <div style={{ overflowX: 'auto', width: '100%', maxWidth: '100%' }}>
                    <div style={customStyle.reviewChoicesScrollBody}>
                        <table style={customStyle.reviewChoicesTable}>
                            <thead>
                                <tr>
                                    {this.state.reviewSummaryData.header.map((headerText, hIndex) => (
                                        <th key={hIndex} style={hIndex === 0 ? customStyle.reviewChoicesTableHeaderCell : customStyle.reviewChoicesTableHeaderCellBold}>{headerText}</th>
                                    ))}
                                </tr>
                            </thead>
                            <tbody>
                                {this.state.reviewSummaryData.body.filter((section) => Array.isArray(section.rows) && section.rows.length).map((section, sectionIndex) => (
                                    section.rows.slice(0, -1).map((row, rowIndex) => (
                                        <tr key={sectionIndex + '-' + rowIndex}>
                                            <td style={customStyle.reviewChoicesTableCell}>{row.text}</td>
                                            <td style={customStyle.reviewChoicesTableCell}>{row.todayAmount}</td>
                                            <td style={customStyle.reviewChoicesTableCell}>{row.regularAmount}</td>
                                        </tr>
                                    ))
                                ))}
                            </tbody>
                            <tfoot>
                                {this.state.reviewSummaryData.body.filter((section) => Array.isArray(section.rows) && section.rows.length).map((section, sectionIndex) => {
                                    const totalRow = section.rows[section.rows.length - 1];
                                    // A single-row section has no separate line items above it (slice(0, -1)
                                    // is empty) — this row is the section's only content, not a bolded total,
                                    // so it shouldn't get the dark #47454a "total" background.
                                    const totalCellStyle = section.rows.length === 1
                                        ? { ...customStyle.reviewChoicesTotalCell, backgroundColor: '#f7f7f7', color: '#19191d' }
                                        : customStyle.reviewChoicesTotalCell;
                                    return (
                                        <tr key={'total-' + sectionIndex} style={customStyle.reviewChoicesTotalRow}>
                                            <td style={totalCellStyle}>{totalRow.text}</td>
                                            <td style={totalCellStyle}>{totalRow.todayAmount}</td>
                                            <td style={totalCellStyle}>{totalRow.regularAmount}</td>
                                        </tr>
                                    );
                                })}
                                {(() => {
                                    const grandTotalEntry = this.state.reviewSummaryData.body.find((item) => !Array.isArray(item.rows));
                                    return grandTotalEntry ? (
                                        <tr style={customStyle.reviewChoicesTotalRow}>
                                            <td style={customStyle.reviewChoicesTotalCell}>{grandTotalEntry.title}</td>
                                            <td style={customStyle.reviewChoicesTotalCell}>{grandTotalEntry.todayAmount}</td>
                                            <td style={customStyle.reviewChoicesTotalCell}>{grandTotalEntry.regularAmount}</td>
                                        </tr>
                                    ) : null;
                                })()}
                            </tfoot>
                        </table>
                    </div>
                </div>
                {/* <p style={{fontSize:'11px', fontWeight:'bold', paddingTop:'10px', marginBottom: 0}}>*The total amount will include a 3.5% charge for the use of a credit card as your payment method. To avoid the charge, please use ACH as your payment method in the screen that follows.</p> */}
            </div>
        );
    }

    renderFamilyDetails() {
        if (!this.state.reviewFamilyData) {
            return <div style={{ padding: '20px', fontSize:'14px', fontFamily : 'Roboto, Arial, Helvetica, sans-serif' }}>No data available.</div>;
        }
        // Flat shape from /quote/review-choices: header is ["Family Member", "<Plan>", "Surcharge", "Total"],
        // rows are [{memberId, name, plan, surcharge, total}, ...] with a trailing {name: "Family Total", ...} row.
        const familyHeader = this.state.reviewFamilyData.header || [];
        const rows = this.state.reviewFamilyData.rows || [];
        const memberRows = rows.filter((row) => row.name !== 'Family Total');
        const totalRow = rows.find((row) => row.name === 'Family Total');
        return (
            <div>
                <div style={{ overflowX: 'auto', width: '100%', maxWidth: '100%' }}>
                    <div style={customStyle.reviewChoicesScrollBody}>
                        <table style={customStyle.reviewChoicesTable}>
                            <thead>
                                <tr style={{borderBottom: '1px solid #fff'}}>
                                    {familyHeader.map((headerText, hIndex) => (
                                        <th key={hIndex} style={hIndex === 0 ? customStyle.reviewChoicesTableHeaderCell : customStyle.reviewChoicesTableHeaderCellBold}>{headerText}</th>
                                    ))}
                                </tr>
                            </thead>
                            <tbody>
                                {memberRows.map((row, rowIndex) => (
                                    <tr key={row.memberId || rowIndex}>
                                        <td style={customStyle.reviewChoicesTableCellFamily}>{row.name}</td>
                                        <td style={customStyle.reviewChoicesTableCellFamily}>{row.plan}</td>
                                        <td style={customStyle.reviewChoicesTableCellFamily}>{row.surcharge}</td>
                                        <td style={customStyle.reviewChoicesTableCellHighlight}>{row.total}</td>
                                    </tr>
                                ))}
                            </tbody>
                            {totalRow &&
                                <tfoot>
                                    <tr style={customStyle.reviewChoicesTotalRow}>
                                        <td style={customStyle.reviewChoicesTotalCell}>{totalRow.name}</td>
                                        <td style={customStyle.reviewChoicesTotalCell}>{totalRow.plan}</td>
                                        <td style={customStyle.reviewChoicesTotalCell}>{totalRow.surcharge}</td>
                                      <td
                                            style={{
                                                ...customStyle.reviewChoicesTotalCell,
                                                backgroundColor: "#000",
                                            }}
                                            >
                                            {totalRow.total}
                                            </td>
                                    </tr>
                                </tfoot>
                            }
                        </table>
                    </div>
                </div>
                {/* <p style={{fontSize:'11px', fontWeight:'bold', paddingTop:'10px', marginBottom: 0}}>*The total amount will include a 3.5% charge for the use of a credit card as your payment method. To avoid the charge, please use ACH as your payment method in the screen that follows.</p> */}
            </div>
        );
    }

    render() {
        const { classes } = this.props;
        let currentScreen
             currentScreen = <Grid container spacing={2}>
                <Grid item xs={12} sm={12}>
                    <div style={{textAlign : 'justify', width : '95%'}}>
                    {<p>
                          If you want to make changes to your selections, click on the <b>BACK</b> button at the bottom and select or unselect your choices on previous screens.

                        </p>}</div>
                </Grid>

                <Grid item xs={12} sm={12}>
                    <div style={customStyle.reviewChoicesTabsStep} className="reviewChoicesTabsResponsive">
                        <div
                            style={this.state.reviewChoicesTab === 'summary' ? customStyle.reviewChoicesTabActiveStep : customStyle.reviewChoicesTabInactiveStep}
                            className="reviewChoicesTabResponsive"
                            onClick={() => this.setState({ reviewChoicesTab: 'summary' })}
                        >PROGRAM SUMMARY</div>
                        <div
                            style={this.state.reviewChoicesTab === 'family' ? customStyle.reviewChoicesTabActiveStep : customStyle.reviewChoicesTabInactiveStep}
                            className="reviewChoicesTabResponsive"
                            onClick={() => this.setState({ reviewChoicesTab: 'family' })}
                        >FAMILY DETAILS</div>
                    </div>
                    <div style={{padding:  window.innerWidth <= 768 ? '16px' :'16px 22% 16px 16px', backgroundColor: '#fff'}}>{this.state.reviewChoicesTab === 'summary' ? this.renderProgramSummary() : this.renderFamilyDetails()}</div>
                </Grid>
            </Grid>


        return (
            <div style={{flexGrow: 1, display: 'flex', flexDirection: 'column'}}>
                {
                    this.state.loaderShow ? <Loader></Loader> : ''
                }
                <Grid container style={{ fontFamily : 'Roboto, Arial, Helvetica, sans-serif', fontSize : '14px', flexDirection: 'column', flex: '1 1 auto'}}>


                    <Grid item xs={12} sm={12} md={12} lg={12}>
                        {currentScreen}
                    </Grid>
                    <Grid item xs={12} sm={6} style={{marginTop : 'auto'}}>
                        <div style={{display: 'flex', flexWrap: 'wrap', gap: '24px'}}>
                            <BackButton
                                          disabled={false}
                                          variant="contained"
                                          onClick={this.handleBack}>BACK
                            </BackButton>
                            <ProceedButton disabled={false}
                                           variant="contained"
                                           onClick={this.handleProceed}>PROCEED
                            </ProceedButton>
                        </div>
                    </Grid>
                </Grid>
            </div>
        );
    }
    handleAddOn(){
        if(!this.state.check)
        this.setState({check:true})
        else
        this.setState({check:false})
    }
}

const mapStateToProps = state => {
    return {
        subId: state.subId,
        email : state.email
    };
}


export default withStyles(styles)(connect(mapStateToProps)(ReviewChoice));
